//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'St53Cn3020List',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/st53/cn3020',
      pageTitle: '现场机信息（日志）',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'dataTime',
        colName: 'data_time',
        title: '操作时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'user',
        colName: 'info',
        title: '操作用户',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'details',
        colName: 'info',
        title: '操作日志',
        align: 'center',
        sorter: true
      }]
    };
  },
  created: function created() {},
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.queryParam.siteId = ids[1];
        this.loadData();
      }
    }
  },
  computed: {},
  methods: {
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
    }
  }
};